import React, { useState } from 'react';
import "./NotificationContainer.css";

import { NotificationContext } from "./NotificationContext.js"
import { NotificationContainer } from "./NotificationContainer.js";

/**
 * @description NotificationContextHandler wrapper that allows any of its children to use notifications
 * @param { any } props
 */
export function NotificationContextHandler(props) {
    const [notifications, setNotifications] = useState([]);

    /**
     * @description Adds a notification to the list, and re-renders
     * @param { NotificationDTO } notification
     */
    function addNotification(notification) {
        setNotifications(prev => [...prev, notification]);
    }

    /**
     * @description Removes a notification from the list, and re-renders
     * @param { NotificationDTO } notification
     */
    function removeNotification(notification) {
        setNotifications(prev => prev.filter(n => n.id !== notification.id));
    }

    return (
        <NotificationContext.Provider value={{ notifications, addNotification, removeNotification }}>
            <div className="viewerContainer">
                {props.children}
                <NotificationContainer notifications={notifications} />
            </div>
        </NotificationContext.Provider>
    );
}
